import "@fontsource-variable/inter";
import "./styles.css";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import { App } from "./app";
import { AuthGate } from "./auth";
import { DisplayProvider } from "./display";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 15_000, retry: 1 },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <DisplayProvider>
          <AuthGate>
            <App />
          </AuthGate>
          <Toaster position="bottom-right" />
        </DisplayProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
